import axios from "axios"
import { API_URL } from "components/Common/Utils"

// import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
// const token = accessToken()

//apply base url for axios
// const API_URL = "https://stage-sar-api.applligentdemo.com/"
// const API_URL = "https://sar-stg-app.wulooj.com/"
// console.log(process.env.REACT_APP_MODE)
const axiosApi = axios.create({
  baseURL: API_URL,
})

// Function to Retrieve Token Dynamically
const getAccessToken = () => {
  const authUserString = localStorage.getItem("authUser")
  if (!authUserString) {
    console.error("AuthUser data not found in localStorage")
    return null
  }

  try {
    const authUser = JSON.parse(authUserString)
    return authUser.token ? `${authUser.token}` : null
  } catch (error) {
    console.error("Error parsing authUser JSON:", error)
    return null
  }
}

// axiosApi.defaults.headers.common["Authorization"] = token;
// axiosApi.defaults.headers.common["accept-language"] = "en"
axiosApi.defaults.headers.common["x-api-key"] =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ1c2VyIjoibW9pekBnbWFpbC5jb20iLCJuYW1lIjoibW9peiIsIkFQSV9USU1FIjoxNzM5MjU5MDc2fQ.HjgvIpO2CL5jn9kRNImjeqJ_axtKOoi7qu7DzSR132Pl3EPhQZfQPT7kI8HyTSSa7Tji6ELy1RKOLRsPC6wNcw"

axiosApi.interceptors.request.use(
  config => {
    // const token =
    //   "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5ZTM3YmFlNy1lN2NjLTRmNDYtODY5OC1lMDZjNTMwNGEwMmQiLCJqdGkiOiI2YjgwNjc3YzU3NzRmYjZjZTIzYjI4YzU3MTRlOTM0NmYxNzJkZmEzMTdjNWExODg4NjUyZDRjOGY0MGZjNTY3MDFhYzFmMjQxZWZiODNmMyIsImlhdCI6MTczOTY4MjMxNy42MTE4NTYsIm5iZiI6MTczOTY4MjMxNy42MTE4NTgsImV4cCI6MTc3MTIxODMxNy42MTA5MDEsInN1YiI6IjIiLCJzY29wZXMiOltdfQ.VeSI3Nx9ut-RnsJCnyRFPVv2HWcxhOIFFQog4hRiU2txoPzY_-x21h_LXovV2xM7OGH-OlhN7pc6WJkMPW-Fa3JudDMcDrGfqzc2sc0VSwSLYyH3iPGXRLzGd_0hsfhUCYqHHy99dlxRgQV_3htOEO4S3NnWOGl34YU5IxLYstjld4bBwndEqvl-tkjPbG5-xJnIjcRBi_cIKxHUvO-yPxmT-BIPlbZD5m4r7MCVbPinfV6TYEQ5vkoMAyS7cBKpNKX0faoqhFyLIiIgcZT6ohfODM4MFcBcD3SYOOSm5onqEJ8B_DHPi_G6huNDiNzjpGoSzupnJloNpUZnZzbPtwMSuj-yfVylbW96KQE9DW7NktUS7K6A27bLpAYmGEjP_MYKdFh7wq2F2eDIAlytYMbh2zu6t-y5CRPosz0kRCeZAywcqMmx6RarehEHP1vFkERuzY_0CWDsUfKsu6ABqrqhNK8if6DdDvXFXgyp2yIlBfBJ9g5qskf0qZBel1BUsENNo07YwtGTcZT0UTMPMOyYCy1ntu0aj_KbG3ClOAbEAc4WV0pnNpPz7OeDLksaVyFNM651h0xOsMd9yZWH1vCjlK7iL1nNkD7GzCUq5oMtly4oc3LWu8Juw1OPvFK0r9YSNVeDMDvQj5WpmGfY8RjxP4Vqhwl03nertL6yU70" // Ensure you get the latest token dynamically
    const token = getAccessToken()
    if (token) {
      config.headers["Authorization"] = token
    }

    const language =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("I18N_LANGUAGE")
        : null
    config.headers["Accept-Language"] = language === "sa" ? "ar" : "en"

    return config
  },
  error => Promise.reject(error)
)

// Handle response errors
axiosApi.interceptors.response.use(
  response => {
    if (response.data.statusCode === 403 || response.data.statusCode === 401) {
      return window.dispatchEvent(new CustomEvent("unauthorized"))
    }

    return response
  },
  error => {
    if (error.response) {
      if (
        error.response.status === 403 ||
        (error.response.data && error.response.data.statusCode === 403)
      ) {
        window.dispatchEvent(new CustomEvent("unauthorized"))
      }
    }
    return Promise.reject(error)
  }
)

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data
      }
    })
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data
      }
    })
}

export async function formDataPost(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config }) // Directly pass the FormData object
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data
      }
    })
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data
      }
    })
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data
      }
    })
}
